import {toAgentPoolId} from '../../../../types'

export const STRING_DEFAULT_AGENT_POOL_ID = '0'
export const DEFAULT_AGENT_POOL_ID = toAgentPoolId(STRING_DEFAULT_AGENT_POOL_ID)
export const PROJECT_AGENT_POOL_TYPENAME = 'ProjectAgentPool'
